import styled from '@emotion/styled'
import React from 'react';
import { HorizontalFlex } from '.';

type WithChildren<T = {}> = 
T & { 
    children?: React.ReactNode
};

export function Banner({ children }: WithChildren){

    const Content = styled.div`
        margin-bottom: 1rem;
        padding: 0;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    `

  return (
        <Content>
            <HorizontalFlex>
                {children}
            </HorizontalFlex>
        </Content>
  );
}
